import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '../analytics/analytics.service';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http/http.service';
import { SparketBridgeApi } from '../../api/sparket-bridge/sparket-bridge-api';

@Injectable({
  providedIn: 'root',
})
export class BootupService {
  private httpService = inject(HttpService);
  private analyticsService = inject(AnalyticsService);

  async initialise() {
    const bootupData = await SparketBridgeApi.request(
      this.httpService,
      this.analyticsService,
    ).bootup();
    this.analyticsService.logBreadcrumb('BootupRequestSuccess');

    if (bootupData.minVersion > environment.build) {
      location.reload();
    }
  }
}
